const collapse = (card) => {
  const icon = card.querySelector(".collapsed-icon > svg");
  if (!icon) return;

  card.classList.toggle("collapsed-card");
  icon.classList.toggle("fa-plus");
  icon.classList.toggle("fa-minus");
};

const collapsible = (card) => {
  let header = card.querySelector(".bl_searchForm_header");
  if (!header) {
    header = card.querySelector(".card-header");
    if (!header) return;
  }

  header.addEventListener("click", () => {
    collapse(card);
  });
};

const initialCollapseCard = () => {
  ["turbo:load"].forEach((event) => {
    document.addEventListener(event, () => {
      const card = document.querySelector(".collapse-card");
      if (!card) return;

      collapsible(card);
    });
  });
};

export default initialCollapseCard;
